import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColour",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "inherit",
      d: "M9 2.383V1a1 1 0 0 0-2 0v1.382A4 4 0 0 0 4 6.25a1 1 0 0 0 2 0 2 2 0 1 1 4 0 1 1 0 0 0 2 0 4 4 0 0 0-3-3.867",
      class: "fill-primary"
    }, null, -1),
    _createElementVNode("path", {
      fill: "inherit",
      d: "M15 14.013V8.5a1 1 0 1 0 0-2H1a1 1 0 0 0 0 2V14a1.002 1.002 0 1 0 .123 2h13.75a1.002 1.002 0 0 0 .122-2zm-2 0h-2V8.5h2zM9 14H7V8.5h2zM5 8.5V14H3V8.5z",
      class: "fill-secondary"
    }, null, -1)
  ])))
}
export default { render: render }